import React, { Fragment, useState } from "react";
import { useQuery } from "react-query";
import { GetDadosCorretora } from "../../api/DadosCorretora";
import { GETDADOSCORRETORA } from "../../util/typesReactQuery";
import useAlert from "../../hooks/useAlert";
import { Box, Grid, Card, CardContent, Chip, useTheme } from "@mui/material";
import Subtitulo from "../Textos/Subtitulo";
import Titulo from "../Textos/Titulo";
import useStyles from "./style";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";

export default function Component() {
  const [dadosCorretora, setDadosCorretora] = useState();
  const { showAlertError } = useAlert();
  const classes = useStyles();
  const theme = useTheme();

  useQuery(`GETDADOSCORRETORA`, () => GetDadosCorretora(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (!data || !data?.data) {
        showAlertError(
          "Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: Nenhuma forma de pagamento encontrada - RXKP1 "
        );
        return;
      }

      if (data.errorMessage) {
        showAlertError(
          `Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: ${data.errorMessage} - RG7ZB `
        );
        return;
      }

      if (data.status) setDadosCorretora(data.data);
    },
    onError: (error) => {
      showAlertError(
        `Ops, ocorreu um erro, informe ao suporte tecnico: ${error?.message} -  RI1K8`
      );
    },
  });

  // Função para identificar o tipo de contato e retornar o ícone apropriado
  const getContactIcon = (tipoContato) => {
    const tipo = tipoContato?.descricao?.toLowerCase() || '';
    
    if (tipo.includes('telefone') || tipo.includes('celular') || tipo.includes('whatsapp')) {
      return <CallIcon sx={{ fontSize: 18, mr: 1 }} />;
    } else if (tipo.includes('email')) {
      return <EmailIcon sx={{ fontSize: 18, mr: 1 }} />;
    } else if (tipo.includes('site') || tipo.includes('web')) {
      return <LanguageIcon sx={{ fontSize: 18, mr: 1 }} />;
    } else {
      return <ContactPhoneIcon sx={{ fontSize: 18, mr: 1 }} />;
    }
  };

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      {/* Cabeçalho */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Titulo sx={{ fontSize: "1.8rem", fontWeight: "bold", color: theme.palette.primary.main, mb: 1 }}>
        Nossos dados
        </Titulo>
      
      </Box>

      {/* Informações principais */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Card 
            sx={{ 
              height: "100%", 
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
              }
            }}
          >
            <CardContent sx={{ textAlign: "center", p: 3 }}>
              <Box sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                width: 50,
                height: 50,
                borderRadius: "50%",
                backgroundColor: theme.palette.primary.light,
               color: "white",
                mx: "auto",
                mb: 2
              }}>
                <ApartmentIcon />
              </Box>
              <Titulo sx={{ fontSize: "1.1rem", fontWeight: 600, mb: 1 }}>
                CNPJ
              </Titulo>
              <Subtitulo sx={{ 
                fontSize: "0.95rem", 
                color: theme.palette.text.secondary,
                wordBreak: "break-word"
              }}>
                {dadosCorretora?.cnpj || "Não informado"}
              </Subtitulo>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card 
            sx={{ 
              height: "100%", 
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
              }
            }}
          >
            <CardContent sx={{ textAlign: "center", p: 3 }}>
              <Box sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                width: 50,
                height: 50,
                borderRadius: "50%",
                backgroundColor: theme.palette.info.light,
                color: "white",
                mx: "auto",
                mb: 2
              }}>
                <CorporateFareIcon />
              </Box>
              <Titulo sx={{ fontSize: "1.1rem", fontWeight: 600, mb: 1 }}>
                Razão Social
              </Titulo>
              <Subtitulo sx={{ 
                fontSize: "0.95rem", 
                color: theme.palette.text.secondary,
                wordBreak: "break-word"
              }}>
                {dadosCorretora?.razaoSocial || "Não informado"}
              </Subtitulo>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card 
            sx={{ 
              height: "100%", 
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
              }
            }}
          >
            <CardContent sx={{ textAlign: "center", p: 3 }}>
              <Box sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                width: 50,
                height: 50,
                borderRadius: "50%",
                backgroundColor: theme.palette.success.light,
          color: "white",
                mx: "auto",
                mb: 2
              }}>
                <LocationOnIcon />
              </Box>
              <Titulo sx={{ fontSize: "1.1rem", fontWeight: 600, mb: 1 }}>
                Endereço
              </Titulo>
              <Subtitulo sx={{ 
                fontSize: "0.95rem", 
                color: theme.palette.text.secondary,
                wordBreak: "break-word"
              }}>
                {dadosCorretora?.endereco || "Não informado"}
              </Subtitulo>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Seção de contatos */}
      {dadosCorretora?.contatos?.length > 0 && (
        <Box sx={{ mt: 4 }}>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Titulo sx={{ fontSize: "1.5rem", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <ContactPhoneIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
              Como podemos ajudar?
            </Titulo>
            <Subtitulo sx={{ color: theme.palette.text.secondary, mt: 1 }}>
              Entre em contato conosco através dos canais abaixo
            </Subtitulo>
          </Box>

          <Grid container justifyContent="center">
            <Grid item xs={12} md={8} lg={6}>
              <Card 
                sx={{ 
                  borderRadius: 2,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
                  p: 3
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Box sx={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: theme.palette.primary.main,
                    color: "white",
                    mr: 2
                  }}>
                    <CallIcon />
                  </Box>
                  <Titulo sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
                    Nossos Contatos
                  </Titulo>
                </Box>

                <Grid container spacing={2}>
                  {dadosCorretora.contatos.map((item, index) => (
                    <Grid item xs={12} key={index}>
                      <Box sx={{ 
                        display: "flex", 
                        alignItems: "center", 
                        p: 2, 
                        borderRadius: 2,
                        backgroundColor: "white",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        transition: "all 0.2s",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        }
                      }}>
                        {getContactIcon(item.tipoContato)}
                        <Box sx={{ flexGrow: 1 }}>
                          <Titulo sx={{ fontSize: "0.95rem", fontWeight: 600, mb: 0.5 }}>
                            {item.tipoContato.descricao}
                          </Titulo>
                          <Subtitulo sx={{ fontSize: "0.9rem", color: theme.palette.text.secondary }}>
                            {item.descricao}
                          </Subtitulo>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
}